let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k3Zym")).then(() => parcelRequire('czXBj'));